import { Subscription, timer, BehaviorSubject, filter, delayWhen, tap, switchMap } from 'rxjs';
import { AGENT_API } from '../AgentAPI';
import { Branch, getOnTimeDiffMS, isAPIResponse } from '@golden/gdk-base';
export function createRealTimeService(api, trunk, agentModule) {
    const polling$ = new BehaviorSubject({
        minuteDenominator: 3,
        secondDenominator: 0
    });
    const updateList = [];
    let subscription = new Subscription();
    const start = () => {
        updateList.forEach((obs) => subscription.add(obs.subscribe()));
    };
    const reset = () => {
        if (subscription && !subscription.closed) {
            subscription.unsubscribe();
            subscription = new Subscription();
        }
    };
    const filterAPI = (api) => {
        return filter((res) => isAPIResponse(res, api));
    };
    // AuthService
    updateList.push(api.base.responses.pipe(filterAPI(AGENT_API.AGENT_LOGIN), delayWhen(() => agentModule.auth.isLoggedIn.pipe(filter((result) => result))), tap(() => trunk.next([Branch.AGENT_USER_STATUS, Branch.ME]))), api.base.responses.pipe(filterAPI(AGENT_API.AGENT_LOGOUT), tap(() => {
        reset();
        start();
    })));
    // UserService and Me
    updateList.push(polling$.pipe(switchMap(time => timer(getOnTimeDiffMS(time), time.minuteDenominator * 60 * 1000 + time.secondDenominator * 1000)), filter(() => agentModule.auth.isLoggedIn.value), tap(() => trunk.next([Branch.AGENT_USER_STATUS, Branch.ME]))));
    // AnnouncementService
    updateList.push(polling$.pipe(switchMap(time => timer(getOnTimeDiffMS(time), time.minuteDenominator * 60 * 1000 + time.secondDenominator * 1000)), filter(() => agentModule.auth.isLoggedIn.value), tap(() => {
        trunk.next([Branch.ANNOUNCEMENT]);
        trunk.next([Branch.STAFF_ANNOUNCEMENT]);
    })));
    return {
        get isEnable() {
            return !subscription.closed;
        },
        set isEnable(value) {
            if (value)
                start();
            else
                reset();
        },
        updatePollingTime: (time) => {
            polling$.next(time);
        }
    };
}
//# sourceMappingURL=RealTimeService.js.map